import * as React$1 from "react";

//#region src/components/icon/static/prescription.svg
var _path;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgPrescription = function SvgPrescription$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", {
		fillRule: "evenodd",
		d: "M3 3.162C3 2.52 3.52 2 4.162 2H9.97a4.444 4.444 0 0 1 1.337 8.684l3.208 3.209 4.482-4.482a1.162 1.162 0 0 1 1.643 1.643l-4.482 4.481 4.482 4.482a1.162 1.162 0 0 1-1.643 1.643l-4.482-4.482-4.482 4.482a1.162 1.162 0 0 1-1.642-1.643l4.481-4.482-4.646-4.646H5.323v6.92a1.162 1.162 0 0 1-2.323 0zm2.323 5.404H9.97a2.121 2.121 0 0 0 0-4.243H5.323z",
		clipRule: "evenodd"
	})));
};
var prescription_default = SvgPrescription;

//#endregion
export { prescription_default as default };